import { useLocation } from 'react-router-dom';

import {
  PATH_MISSION_REPORT_INFO_EDIT,
  PATH_MISSION_REPORT_INFO_EDIT_STATE,
} from '../../app/constants/paths.constant';
import { useIdParam } from '../../utils/use-id-param.util';

import { PageGate } from './PageGate';
import { useOpenedAt } from './hooks/useOpenedAt.hook';
import { useReportInfoAccess } from './hooks/useReportInfoAccess.hook';
import { requiredScopeOf } from './utils/required-scope-of.util';
import type { ReportInfoAccess } from './hooks/useReportInfoAccess.hook';

type ReportScope = Exclude<keyof ReportInfoAccess, 'answeredAt'>;

// The scope each edition page of a report requires.
export const REPORT_PAGES_SCOPES: readonly (readonly [string, ReportScope])[] =
  [
    [PATH_MISSION_REPORT_INFO_EDIT, 'update'],
    [PATH_MISSION_REPORT_INFO_EDIT_STATE, 'changeState'],
  ];

// The edition pages of a report of a mission, reached directly by their URL, explain why they are
// refused, as the mission ones do with the access of its report.
export const ReportPagesGuard = () => {
  const { pathname } = useLocation();
  const openedAt = useOpenedAt(pathname);
  const access = useReportInfoAccess(
    useIdParam('missionId'),
    useIdParam('reportInfoId'),
    pathname,
  );
  const scope = requiredScopeOf(REPORT_PAGES_SCOPES, pathname);

  return (
    <PageGate
      gate={scope ? access[scope] : undefined}
      isFresh={access.answeredAt >= openedAt}
    />
  );
};
